module.exports = "/public/dist/img/message.svg";